import React from "react";
import LocalizationContext from "../utils/LocalizationContext";
import NavBar from "../components/NavBar";
import License from "../pages/License";
import useMenu from "../utils/Hooks/useMenu";
import ValidateURL from "../utils/ValidateURL";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.License,
    key: "Licenses",
  };

  return (
    <ValidateURL currentPage={currentPage}>
      <LocalizationContext.Provider value={{}}>
        <NavBar
          MenuOptions={menu}
          currentPage={currentPage}
        >
          <License />
        </NavBar>
      </LocalizationContext.Provider>
    </ValidateURL>
  );
};
